const OWAS_TOTAL_TABLE = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 2, 2, 1, 1, 1, 1, 1, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 2, 2, 3, 2, 2, 3, 1, 1, 1, 1, 1, 2],
  [2, 2, 3, 2, 2, 3, 2, 2, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 3, 3],
  [2, 2, 3, 2, 2, 3, 2, 3, 3, 3, 3, 3, 3, 3, 3, 2, 2, 2, 2, 3, 3],
  [3, 3, 4, 2, 2, 3, 3, 3, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 2, 3, 4],
  [1, 1, 1, 1, 1, 1, 1, 1, 2, 3, 3, 3, 4, 4, 4, 1, 1, 1, 1, 1, 1],
  [2, 2, 3, 1, 1, 1, 1, 1, 2, 4, 4, 4, 4, 4, 4, 3, 3, 3, 1, 1, 1],
  [2, 2, 3, 1, 1, 1, 2, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 1, 1, 1],
  [2, 3, 3, 2, 2, 3, 2, 2, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 3, 4],
  [3, 3, 4, 2, 3, 4, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 3, 4],
  [4, 4, 4, 2, 3, 4, 3, 3, 4, 4, 4, 4, 4, 4, 4, 4, 4, 4, 2, 3, 4],
];

const calculateOwas = pose => {
  // 허리
  const trPose = pose.trunk.pose;
  const trPoseScoreMap = {
    TR_PS_01: 1,
    TR_PS_02: 2,
    TR_PS_03: 3,
    TR_PS_04: 4,
  };
  const trScore = trPoseScoreMap[trPose] || null;

  // 팔
  const armPose = pose.lowerArm.pose;
  const armPoseScoreMap = {
    AA_PS_01: 1,
    AA_PS_02: 2,
    AA_PS_03: 3,
  };
  const armScore = armPoseScoreMap[armPose] || null;

  // 다리
  const legPose = pose.leg.pose;
  const legPoseScoreMap = {
    LG_PS_01: 1,
    LG_PS_02: 2,
    LG_PS_03: 3,
    LG_PS_04: 4,
    LG_PS_05: 5,
    LG_PS_06: 6,
    LG_PS_07: 7,
  };
  const legScore = legPoseScoreMap[legPose] || null;

  // 무게(하중)
  const weightData = pose.weight;
  const weightDataScoreMap = {
    WT_01: 1,
    WT_02: 1,
    WT_03: 1,
    WT_04: 2,
    WT_05: 3,
  };
  const weightScore = weightDataScoreMap[weightData] || null;

  let row = null;
  if (trScore !== null && armScore !== null) {
    row = (trScore - 1) * 3 + (armScore - 1);
  }
  let col = null;
  if (legScore !== null && weightScore !== null) {
    col = (legScore - 1) * 3 + (weightScore - 1);
  }
  let totalScore = null;
  if (row !== null && col !== null) {
    totalScore = OWAS_TOTAL_TABLE[row][col];
  }

  let owasScrRange = null;
  if (totalScore !== null) {
    switch (totalScore) {
      case 1:
        owasScrRange = 1;
        break;
      case 2:
        owasScrRange = 2;
        break;
      case 3:
        owasScrRange = 3;
        break;
      default:
        owasScrRange = 4;
        break;
    }
  }

  const OWAS_SCR = {
    owasTrunkScr: trScore,
    owasArmScr: armScore,
    owasLegScr: legScore,
    owasWeightScr: weightScore,
    owasScr: totalScore,
    owasScrRange: owasScrRange,
  };

  return OWAS_SCR;
};

const RULA_TABLE_A = [
  [1, 2, 2, 2, 2, 3, 3, 3],
  [2, 2, 2, 2, 3, 3, 3, 3],
  [2, 3, 3, 3, 3, 3, 4, 4],
  [2, 3, 3, 3, 3, 4, 4, 4],
  [3, 3, 3, 3, 3, 4, 4, 4],
  [3, 4, 4, 4, 4, 4, 5, 5],
  [3, 3, 4, 4, 4, 4, 5, 5],
  [3, 4, 4, 4, 4, 4, 5, 5],
  [4, 4, 4, 4, 4, 5, 5, 5],
  [4, 4, 4, 4, 4, 5, 5, 5],
  [4, 4, 4, 4, 4, 5, 5, 5],
  [4, 4, 4, 5, 5, 5, 6, 6],
  [5, 5, 5, 5, 5, 6, 6, 7],
  [5, 6, 6, 6, 6, 7, 7, 7],
  [6, 6, 6, 7, 7, 7, 7, 8],
  [7, 7, 7, 7, 7, 8, 8, 9],
  [8, 8, 8, 8, 8, 9, 9, 9],
  [9, 9, 9, 9, 9, 9, 9, 9],
];

const RULA_TABLE_B = [
  [1, 3, 2, 3, 3, 4, 5, 5, 6, 6, 7, 7],
  [2, 3, 2, 3, 4, 5, 5, 5, 6, 7, 7, 7],
  [3, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 7],
  [5, 5, 5, 6, 6, 7, 7, 7, 7, 7, 8, 8],
  [7, 7, 7, 7, 7, 8, 8, 8, 8, 8, 8, 8],
  [8, 8, 8, 8, 8, 8, 8, 9, 9, 9, 9, 9],
];

const RULA_TABLE_C = [
  [1, 2, 3, 3, 4, 5, 5],
  [2, 2, 3, 4, 4, 5, 5],
  [3, 3, 3, 4, 4, 5, 6],
  [3, 3, 3, 4, 5, 6, 6],
  [4, 4, 4, 5, 6, 7, 7],
  [4, 4, 5, 6, 6, 7, 7],
  [5, 5, 6, 6, 7, 7, 7],
  [5, 5, 6, 7, 7, 7, 7],
];

const calculateRula = pose => {
  // 상박
  const upperArmPosition = pose.upperArm.position;
  const upperArmPositionScoreMap = {
    UA_PT_01: 2,
    UA_PT_02: 1,
    UA_PT_03: 2,
    UA_PT_04: 3,
    UA_PT_05: 4,
  };
  let upperArmScore = upperArmPositionScoreMap[upperArmPosition] || null;

  if (upperArmScore !== null) {
    const { UA_AJ_01, UA_AJ_02, UA_AJ_03 } = pose.upperArm.adjust.check;
    upperArmScore += UA_AJ_01 === 'Y' ? 1 : 0;
    upperArmScore += UA_AJ_02 === 'Y' ? 1 : 0;
    upperArmScore -= UA_AJ_03 === 'Y' ? 1 : 0;
  }

  // 하박
  const lowerArmPosition = pose.lowerArm.position;
  const lowerArmPositionScoreMap = {
    LA_PT_01: 2,
    LA_PT_02: 1,
    LA_PT_03: 2,
  };
  let lowerArmScore = lowerArmPositionScoreMap[lowerArmPosition] || null;

  if (lowerArmScore !== null) {
    const { LA_AJ_01 } = pose.lowerArm.adjust.check;
    lowerArmScore += LA_AJ_01 === 'Y' ? 1 : 0;
  }

  // 손목
  const wristPosition = pose.wrist.position;
  const wristPositionScoreMap = {
    WR_PT_01: 3,
    WR_PT_02: 1,
    WR_PT_03: 2,
    WR_PT_04: 3,
  };
  let wristScore = wristPositionScoreMap[wristPosition] || null;

  if (wristScore !== null) {
    const { WR_AJ_03 } = pose.wrist.adjust.check;
    wristScore += WR_AJ_03 === 'Y' ? 1 : 0;
  }

  // 손목 비틀림
  const wristAdjust = pose.wrist.adjust.select;
  const wristTwistScoreMap = {
    WR_AJ_00: 1,
    WR_AJ_01: 1,
    WR_AJ_02: 2,
  };
  let wristTwistScore = wristTwistScoreMap[wristAdjust] || null;

  // TABLE A 점수
  let tableARow = null;
  if (upperArmScore !== null && lowerArmScore !== null) {
    tableARow = (upperArmScore - 1) * 3 + (lowerArmScore - 1);
  }
  let tableACol = null;
  if (wristScore !== null && wristTwistScore !== null) {
    tableACol = (wristScore - 1) * 2 + (wristTwistScore - 1);
  }
  let tableAScore = null;
  if (tableARow !== null && tableACol !== null) {
    tableAScore = RULA_TABLE_A[tableARow][tableACol];
  }

  // 목
  const neckPosition = pose.neck.position;
  const neckPositionScoreMap = {
    NC_PT_01: 4,
    NC_PT_02: 1,
    NC_PT_03: 2,
    NC_PT_04: 3,
  };
  let neckScore = neckPositionScoreMap[neckPosition] || null;

  if (neckScore !== null) {
    const { NC_AJ_01, NC_AJ_02 } = pose.neck.adjust.check;
    neckScore += NC_AJ_01 === 'Y' ? 1 : 0;
    neckScore += NC_AJ_02 === 'Y' ? 1 : 0;
  }

  // 몸통
  const trunkPosition = pose.trunk.position;
  const trunkPositionScoreMap = {
    TR_PT_01: 1,
    TR_PT_02: 1,
    TR_PT_03: 1,
    TR_PT_04: 2,
    TR_PT_05: 3,
    TR_PT_06: 4,
  };
  let trunkScore = trunkPositionScoreMap[trunkPosition] || null;

  const { LG_AJ_03, LG_AJ_04 } = pose.leg.adjust.check;
  if (LG_AJ_03 === 'Y' || LG_AJ_04 === 'Y') {
    trunkScore = 1;

    if (LG_AJ_04 === 'Y') {
      trunkScore += 1;
    }
  }

  if (trunkScore !== null) {
    // if (['TR_PT_01', 'TR_PT_02'].includes(trunkPosition)) {
    //   if (pose.add.AD_05 === 'Y') {
    //     trunkScore += 1;
    //   }
    // }

    const { TR_AJ_01, TR_AJ_02 } = pose.trunk.adjust.check;
    trunkScore += TR_AJ_01 === 'Y' ? 1 : 0;
    trunkScore += TR_AJ_02 === 'Y' ? 1 : 0;
  }

  // 다리
  let legScore = 1;
  const legPosition = pose.leg.position;
  const legPositionScoreMap = {
    LG_PT_01: 1,
    LG_PT_02: 2,
  };
  legScore = legPositionScoreMap[legPosition] || null;

  // TABLE B 점수
  let tableBRow = null;
  if (neckScore !== null) {
    tableBRow = neckScore - 1;
  }
  let tableBCol = null;
  if (trunkScore !== null && legScore !== null) {
    tableBCol = (trunkScore - 1) * 2 + (legScore - 1);
  }
  let tableBScore = null;
  if (tableBRow !== null && tableBCol !== null) {
    tableBScore = RULA_TABLE_B[tableBRow][tableBCol];
  }

  // 근육 사용 점수 A
  let muscleUseScore = 0;
  const { AD_01, AD_02, AD_03 } = pose.add;
  if (AD_01 === 'Y' || AD_02 === 'Y') {
    muscleUseScore += 1;
  }

  // 무게, 빈도 점수
  let weightFrequencyScore = 0;
  const weightData = pose.weight;
  const frequencyData = pose.frequency;

  if (['WT_02', 'WT_03'].includes(weightData)) {
    if (frequencyData === 'FQ_01') {
      weightFrequencyScore = 1;
    } else if (frequencyData === 'FQ_02') {
      weightFrequencyScore = 2;
    }
  } else if (
    ['WT_04', 'WT_05'].includes(weightData) ||
    AD_01 === 'Y' ||
    AD_02 === 'Y' ||
    frequencyData === 'FQ_03'
  ) {
    weightFrequencyScore = 3;
  }

  // TABLE C 점수
  let tableCRow = null;
  let tableCCol = null;
  let tableCScore = null;
  if (tableAScore !== null) {
    tableCRow = tableAScore + muscleUseScore + weightFrequencyScore;

    if (tableCRow > 8) {
      tableCRow = 8;
    }

    tableCRow = tableCRow - 1;
  }
  if (tableBScore !== null) {
    tableCCol = tableBScore + muscleUseScore + weightFrequencyScore;

    if (tableCCol > 7) {
      tableCCol = 7;
    }

    tableCCol = tableCCol - 1;
  }
  if (tableCRow !== null && tableCCol !== null) {
    tableCScore = RULA_TABLE_C[tableCRow][tableCCol];
  }

  let rulaScrRange = null;
  if (tableCScore !== null) {
    switch (tableCScore) {
      case 1:
      case 2:
        rulaScrRange = 1;
        break;
      case 3:
      case 4:
        rulaScrRange = 3;
        break;
      case 5:
      case 6:
        rulaScrRange = 5;
        break;
      default:
        rulaScrRange = 7;
        break;
    }
  }

  const RULA_SCR = {
    rulaNeckScr: neckScore,
    rulaUpperArmScr: upperArmScore,
    rulaLowerArmScr: lowerArmScore,
    rulaWristScr: wristScore,
    rulaWristTwistScr: wristTwistScore,
    rulaTrunkScr: trunkScore,
    rulaLegScr: legScore,
    rulaScr: tableCScore,
    rulaScrRange: rulaScrRange,
  };

  return RULA_SCR;
};

const REBA_TABLE_A = [
  [1, 2, 3, 4, 1, 2, 3, 4, 3, 3, 5, 6],
  [2, 3, 4, 5, 3, 4, 5, 6, 4, 5, 6, 7],
  [2, 4, 5, 6, 4, 5, 6, 7, 5, 6, 7, 8],
  [3, 5, 6, 7, 5, 6, 7, 8, 6, 7, 8, 9],
  [4, 6, 7, 8, 6, 7, 8, 9, 7, 8, 9, 9],
];

const REBA_TABLE_B = [
  [1, 2, 2, 1, 2, 3],
  [1, 2, 3, 2, 3, 4],
  [3, 4, 5, 4, 5, 5],
  [4, 5, 5, 5, 6, 7],
  [6, 7, 8, 7, 8, 8],
  [7, 8, 8, 8, 9, 9],
];

const REBA_TABLE_C = [
  [1, 1, 1, 2, 3, 3, 4, 5, 6, 7, 7, 7],
  [1, 2, 2, 3, 4, 4, 5, 6, 6, 7, 7, 8],
  [2, 3, 3, 3, 4, 5, 6, 7, 7, 8, 8, 8],
  [3, 4, 4, 4, 5, 6, 7, 8, 8, 9, 9, 9],
  [4, 4, 4, 5, 6, 7, 8, 8, 9, 9, 9, 9],
  [6, 6, 6, 7, 8, 8, 9, 9, 10, 10, 10, 10],
  [7, 7, 7, 8, 9, 9, 9, 10, 10, 11, 11, 11],
  [8, 8, 8, 9, 10, 10, 10, 10, 10, 11, 11, 11],
  [9, 9, 9, 10, 10, 10, 11, 11, 11, 12, 12, 12],
  [10, 10, 10, 11, 11, 11, 11, 12, 12, 12, 12, 12],
  [11, 11, 11, 11, 12, 12, 12, 12, 12, 12, 12, 12],
  [12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12, 12],
];

const calulateReba = pose => {
  // 목
  const neckPosition = pose.neck.position;
  const neckPositionScoreMap = {
    NC_PT_01: 2,
    NC_PT_02: 1,
    NC_PT_03: 1,
    NC_PT_04: 2,
  };
  let neckScore = neckPositionScoreMap[neckPosition] || null;

  if (neckScore !== null) {
    const { NC_AJ_01, NC_AJ_02 } = pose.neck.adjust.check;
    if (NC_AJ_01 === 'Y' || NC_AJ_02 === 'Y') {
      neckScore += 1;
    }
  }

  // 몸통
  const trunkPosition = pose.trunk.position;
  const trunkPositionScoreMap = {
    TR_PT_01: 3,
    TR_PT_02: 2,
    TR_PT_03: 1,
    TR_PT_04: 2,
    TR_PT_05: 3,
    TR_PT_06: 4,
  };
  let trunkScore = trunkPositionScoreMap[trunkPosition] || null;

  if (trunkScore !== null) {
    const { TR_AJ_01, TR_AJ_02 } = pose.trunk.adjust.check;
    if (TR_AJ_01 === 'Y' || TR_AJ_02 === 'Y') {
      trunkScore += 1;
    }
  }

  // 다리
  const legPosition = pose.leg.position;

  const legPositionScoreMap = {
    LG_PT_01: 2,
    LG_PT_02: 1,
  };
  let legScore = legPositionScoreMap[legPosition] || null;

  const legAdjustPosition = pose.leg.adjust.select;
  const legAdjustPositionScoreMap = {
    LG_AJ_01: 1,
    LG_AJ_02: 2,
  };

  const { LG_AJ_03, LG_AJ_04 } = pose.leg.adjust.check;
  if (LG_AJ_03 === 'Y' || LG_AJ_04 === 'Y') {
    legScore = 1;

    legAdjustPosition === 'LG_AJ_01' && (legScore += 1);
  } else {
    let legAdjustScore = legAdjustPositionScoreMap[legAdjustPosition] || 0;

    legScore += legAdjustScore;
  }

  // TABLE A 점수
  let tableARow = null;
  if (trunkScore !== null) {
    tableARow = trunkScore - 1;
  }
  let tableACol = null;
  if (neckScore !== null && legScore !== null) {
    tableACol = (neckScore - 1) * 4 + (legScore - 1);
  }
  let tableAScore = null;
  if (tableARow !== null && tableACol !== null) {
    tableAScore = REBA_TABLE_A[tableARow][tableACol];
  }

  // 어깨
  const upperArmPosition = pose.upperArm.position;
  const upperArmPositionScoreMap = {
    UA_PT_01: 2,
    UA_PT_02: 1,
    UA_PT_03: 2,
    UA_PT_04: 3,
    UA_PT_05: 4,
  };
  let upperArmScore = upperArmPositionScoreMap[upperArmPosition] || null;

  if (upperArmScore !== null) {
    const { UA_AJ_01, UA_AJ_02, UA_AJ_03 } = pose.upperArm.adjust.check;
    upperArmScore += UA_AJ_01 === 'Y' ? 1 : 0;
    upperArmScore += UA_AJ_02 === 'Y' ? 1 : 0;
    upperArmScore -= UA_AJ_03 === 'Y' ? 1 : 0;
  }

  // 팔
  const lowerArmPosition = pose.lowerArm.position;
  const lowerArmPositionScoreMap = {
    LA_PT_01: 2,
    LA_PT_02: 1,
    LA_PT_03: 2,
  };
  let lowerArmScore = lowerArmPositionScoreMap[lowerArmPosition] || null;

  // 손목
  const wristPosition = pose.wrist.position;
  const wristPositionScoreMap = {
    WR_PT_01: 2,
    WR_PT_02: 1,
    WR_PT_03: 1,
    WR_PT_04: 2,
  };
  let wristScore = wristPositionScoreMap[wristPosition] || null;

  const wristAdjust = pose.wrist.adjust.select;
  const wristTwistScoreMap = {
    WR_AJ_01: 1,
    WR_AJ_02: 1,
  };
  let wristAdjustScore = wristTwistScoreMap[wristAdjust] || null;

  if (wristScore !== null) {
    const { WR_AJ_03 } = pose.wrist.adjust.check;

    let wristAddScore = 0;
    if (WR_AJ_03 === 'Y') {
      wristAddScore = 1;
    }
    if (wristAdjustScore !== null) {
      wristAddScore = 1;
    }

    wristScore += wristAddScore;
  }

  // TABLE B 점수
  let tableBRow = null;
  if (upperArmScore !== null) {
    tableBRow = upperArmScore - 1;
  }
  let tableBCol = null;
  if (lowerArmScore !== null && wristScore !== null) {
    tableBCol = (lowerArmScore - 1) * 3 + (wristScore - 1);
  }
  let tableBScore = null;
  if (tableBRow !== null && tableBCol !== null) {
    tableBScore = REBA_TABLE_B[tableBRow][tableBCol];
  }

  // 무게 점수
  const weightData = pose.weight;
  const weightScoreMap = {
    WT_01: 0,
    WT_02: 0,
    WT_03: 1,
    WT_04: 2,
    WT_05: 2,
  };
  let weightScore = weightScoreMap[weightData] ?? null;

  // 무게 보정
  const frequencyData = pose.frequency;
  if (frequencyData === 'FQ_03') {
    weightScore += 1;
  }

  // Score A
  let scoreA = null;
  if (tableAScore !== null && weightScore !== null) {
    scoreA = tableAScore + weightScore;
  }

  // 손잡이 점수
  const handleData = pose.handle;
  const handleScoreMap = {
    HD_01: 0,
    HD_02: 1,
    HD_03: 2,
    HD_04: 3,
  };
  const handleScore = handleScoreMap[handleData] ?? null;

  // Score B
  let scoreB = null;
  if (tableBScore !== null && handleScore !== null) {
    scoreB = tableBScore + handleScore;
  }

  // TALBE C 점수
  let tableCScore = null;
  if (scoreA !== null && scoreB !== null) {
    tableCScore = REBA_TABLE_C[scoreA - 1][scoreB - 1];
  }

  // Activity Score
  const { AD_01, AD_02, AD_03 } = pose.add;
  let activityScore = 0;
  activityScore += AD_01 === 'Y' ? 1 : 0;
  activityScore += AD_02 === 'Y' ? 1 : 0;
  activityScore += AD_03 === 'Y' ? 1 : 0;

  // reba 점수
  let rebaScore = null;
  if (tableCScore !== null && activityScore !== null) {
    rebaScore = tableCScore + activityScore;
  }

  let rebaScrRange = null;
  if (rebaScore !== null) {
    switch (rebaScore) {
      case 1:
        rebaScrRange = 1;
        break;
      case 2:
      case 3:
        rebaScrRange = 2;
        break;
      case 4:
      case 5:
      case 6:
      case 7:
        rebaScrRange = 4;
        break;
      case 8:
      case 9:
      case 10:
        rebaScrRange = 8;
        break;
      default:
        rebaScrRange = 11;
        break;
    }
  }

  const REBA_SCR = {
    rebaNeckScr: neckScore,
    rebaTrunkScr: trunkScore,
    rebaLegScr: legScore,
    rebaUpperArmScr: upperArmScore,
    rebaLowerArmScr: lowerArmScore,
    rebaWristScr: wristScore,
    rebaScr: rebaScore,
    rebaScrRange: rebaScrRange,
  };

  return REBA_SCR;
};

const analyzePose = pose => {
  const OWAS_SCR = calculateOwas(pose);
  const RULA_SCR = calculateRula(pose);
  const REBA_SCR = calulateReba(pose);

  const returnScr = {
    ...OWAS_SCR,
    ...RULA_SCR,
    ...REBA_SCR,
  };

  return returnScr;
};
export default analyzePose;
